import { Link } from 'react-router-dom';
import { getHotComics } from '@/mocks/comics';

export default function HotRanking() {
  const hotComics = getHotComics(10);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">
          <div className="lg:w-2/3">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
                  热门<strong className="text-primary-500">排行</strong>
                </h2>
                <p className="mt-1 text-sm text-foreground-500">本周最受欢迎的韩漫作品</p>
              </div>
            </div>
            <div className="space-y-3">
              {hotComics.slice(0, 5).map((comic, index) => {
                const formatViews = (views: number): string => {
                  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
                  return views.toString();
                };
                return (
                  <Link
                    key={comic.id}
                    to={`/article/${comic.id}`}
                    className="flex items-center gap-4 p-4 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
                  >
                    <span className={`text-2xl font-heading w-10 h-10 flex items-center justify-center rounded-full ${
                      index === 0 ? 'bg-primary-500 text-background-50' :
                      index === 1 ? 'bg-accent-500 text-background-50' :
                      index === 2 ? 'bg-secondary-500 text-background-50' :
                      'bg-background-200 text-foreground-500'
                    }`}>
                      {index + 1}
                    </span>
                    <div className="w-14 h-20 flex-shrink-0 rounded overflow-hidden bg-background-200">
                      <img src={comic.coverImage} alt={comic.title} className="w-full h-full object-cover object-top" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                        {comic.title}
                      </h3>
                      <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                      <div className="flex items-center gap-3 mt-1.5 flex-wrap">
                        <span className="text-xs text-accent-500 whitespace-nowrap">★ {comic.rating}</span>
                        <span className="text-xs text-foreground-400 whitespace-nowrap">{formatViews(comic.views)} 阅读</span>
                        <span className="text-xs text-primary-500 whitespace-nowrap">{comic.status}</span>
                      </div>
                    </div>
                    <div className="hidden sm:flex flex-wrap gap-1.5">
                      {comic.tags.map((tag) => (
                        <span key={tag} className="px-2 py-0.5 rounded-md bg-background-200 text-foreground-500 text-xs whitespace-nowrap">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>

          <div className="lg:w-1/3">
            <div className="sticky top-24">
              <div className="bg-background-100 rounded-lg p-5">
                <h3 className="text-lg font-heading text-foreground-950 mb-4">
                  <i className="ri-fire-line text-accent-500 w-5 h-5 inline-flex items-center justify-center align-middle mr-1"></i>
                  本周飙升榜
                </h3>
                <div className="space-y-3">
                  {hotComics.slice(5, 10).map((comic, index) => (
                    <Link
                      key={comic.id}
                      to={`/article/${comic.id}`}
                      className="flex items-center gap-3 group cursor-pointer"
                    >
                      <span className="text-xs font-medium text-foreground-400 w-4 text-right whitespace-nowrap">
                        {index + 6}
                      </span>
                      <div className="w-10 h-14 flex-shrink-0 rounded overflow-hidden bg-background-200">
                        <img src={comic.coverImage} alt={comic.title} className="w-full h-full object-cover object-top" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                          {comic.title}
                        </p>
                        <p className="text-xs text-foreground-500 mt-0.5">{comic.status} · ★{comic.rating}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>

              <div className="mt-5 bg-accent-100/50 rounded-lg p-5">
                <h3 className="text-sm font-medium text-foreground-950 mb-2">📢 公告</h3>
                <ul className="space-y-2 text-xs text-foreground-600">
                  <li className="flex items-start gap-2">
                    <span className="w-1 h-1 rounded-full bg-accent-500 mt-1.5 flex-shrink-0"></span>
                    <span>本周新增50+部韩国漫画资源</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-1 h-1 rounded-full bg-accent-500 mt-1.5 flex-shrink-0"></span>
                    <span>阅读器升级，翻页速度提升30%</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-1 h-1 rounded-full bg-accent-500 mt-1.5 flex-shrink-0"></span>
                    <span>新增夜间模式，护眼更舒适</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}